export const pa = {
    "TRIGGER_LISTEN": "ਟਰਿੱਗਰਾਂ ਲਈ ਸੁਣ ਰਿਹਾ ਹੈ,",
    "ASSIST_EMPTY_MSG": "ਏਜੰਟ ਏਆਈ ਤੁਹਾਡੀ ਗੱਲਬਾਤ ਨੂੰ ਸਰਗਰਮ ਤੌਰ 'ਤੇ ਸੁਣ ਰਿਹਾ ਹੈ ਅਤੇ ਟਰਿੱਗਰ ਹੋਣ 'ਤੇ ਸਵੈਚਲਿਤ ਤੌਰ 'ਤੇ ਸਹਾਇਤਾ ਕਰਨ ਲਈ ਤਿਆਰ ਹੈ,",
    "MYBOT_TRIGGET_LISTEN": "ਵਰਤਮਾਨ ਵਿੱਚ ਕੋਈ ਸਰਗਰਮ ਮੇਰੇ ਬੋਟ ਕਾਰਜ ਨਹੀਂ ਹਨ,",
    "MYBOT_EMTPY_MSG": "ਮੇਰੇ ਬੋਟ 'ਤੇ ਕਾਰਜ ਸ਼ੁਰੂ ਕਰਨ ਲਈ, ਖੋਜ ਟੈਬ 'ਤੇ ਜਾਓ ਅਤੇ ਆਪਣੇ ਚਾਹੁੰਦੇ ਕਾਰਜ ਲਈ \"\"ਏਜੰਟ ਇਨਪੁਟਸ ਨਾਲ ਚਲਾਓ\"\" ਵਿਕਲਪ ਚੁਣੋ,",
    "PROACTIVE_MODE": "ਪ੍ਰੋਐਕਟਿਵ ਮੋਡ,",
    "SETTINGS": "ਸੈਟਿੰਗਾਂ,",
    "HELP_AND_SUPPORT": "ਮਦਦ ਅਤੇ ਸਹਾਇਤਾ,",
    "HELP": "ਮਦਦ,",
    "LANGUAGE": "ਭਾਸ਼ਾ,",
    "THEME": "ਥੀਮ,",
    "AUTOMATIC": "ਸਵੈਚਲਿਤ,",
    "FILE_NAME":"ਫਾਇਲ ਨਾਮ",
    "DARK": "ਹਨੇਰਾ,",
    "AUTO_SCROLL_TOOLTIP":"ਸਹਾਇਤਾ ਟੈਬ, ਮੇਰਾ ਬੌਟ ਅਤੇ ਟ੍ਰਾਂਸਕ੍ਰਿਪਟ ਟੈਬ ਸਮੱਗਰੀ ਦੀ ਆਟੋ-ਸਕ੍ਰੋਲਿੰਗ ਨੂੰ ਨਿਯੰਤਰਿਤ ਕਰਦਾ ਹੈ",
    "LIGHT": "ਪ੍ਰਕਾਸ਼,",
    "THEME_DESC": "ਇਹ ਤੁਹਾਡੇ ਸਿਸਟਮ ਡਿਫੌਲਟ ਮੋਡ ਦਾ ਉਪਯੋਗ ਕਰੇਗਾ,",
    "DOCUMENTATION": "ਦਸਤਾਵੇਜ਼ੀਕਰਣ,",
    "DOC_DESC": "ਸਾਡੇ ਵਿਸਥਾਰ ਵਿੱਚ ਦਸਤਾਵੇਜ਼ੀਕਰਣ ਲੇਖ ਵੇਖੋ,",
    "FAQ_U": "ਅਕਸਰ ਪੁੱਛੇ ਜਾਣ ਵਾਲੇ ਪ੍ਰਸ਼ਨ,",
    "FAQ_DESC": "ਏਜੰਟ ਏਆਈ ਬਾਰੇ ਅਕਸਰ ਪੁੱਛੇ ਜਾਣ ਵਾਲੇ ਪ੍ਰਸ਼ਨ ਵੇਖੋ,",
    "KORE_ACADEMY": "ਕੋਰੇ ਅਕੈਡਮੀ,",
    "KORE_ACA_DESC": "ਅਕੈਡਮੀ ਕੋਰਸਾਂ ਵਿੱਚੋਂ ਲੰਘ ਕੇ ਏਜੰਟ ਏਆਈ ਬਾਰੇ ਹੋਰ ਜਾਨੋ,",
    "TAB_TEXT":"ਕੋਈ ਟੈਬ ਸਰਗਰਮ ਨਹੀਂ! ਕਿਰਪਾ ਕਰਕੇ ਘੱਟੋ ਘੱਟ ਇੱਕ ਟੈਬ ਸਰਗਰਮ ਕਰੋ",
    "SEARCH": "ਖੋਜੋ,",
    "MY_BOT": "ਮੇਰਾ ਬੋਟ,",
    "ASSIST": "ਮਦਦ ਕਰੋ,",
    "TRANSCRIPT": "ਪ੍ਰਤਿਲਿਪੀ,",
    "HISTORY": "ਇਤਿਹਾਸ,",
    "STARTOVER": "ਮੁੜ ਸ਼ੁਰੂ ਕਰੋ,",
    "RESTART_INPUTS": "ਕੈਪਚਰ ਕੀਤੇ ਇਨਪੁਟਸ ਨਾਲ ਮੁੜ ਸ਼ੁਰੂ ਕਰੋ,",
    "ASKCUSTOMER": "ਗਾਹਕ ਨੂੰ ਪੁੱਛੋ,",
    "TELLCUSTOMER": "ਗਾਹਕ ਨੂੰ ਦੱਸੋ,",
    "WELCOME_MSG": "ਸਵਾਗਤ ਸੰਦੇਸ਼,",
    "TAP_SEARCH":"ਖੋਜਣ ਲਈ ਟੈਪ ਕਰੋ",
    "SEND": "ਭੇਜੋ,",
    "SENT": "ਭੇਜਿਆ ਗਿਆ,",
    "AWAITING": "ਜਵਾਬ ਦੀ ਉਡੀਕ | ਜਾਰੀ ਰੱਖਣ ਲਈ ਟਾਈਪ ਕਰੋ,",
    "OVERRIDE": "ਜਾਰੀ ਰੱਖਣ ਲਈ ਟਾਈਪ ਕਰੋ,",
    "OVERRIDE_FILE": "ਜਾਰੀ ਰੱਖਣ ਲਈ ਫਾਈਲ ਜੋੜੋ,",
    "ACCEPT_RESPONSE": "ਜਵਾਬ ਸਵੀਕਾਰਿਆ ਗਿਆ,",
    "AGENT_ENTERED": "ਏਜੰਟ ਦਾਖਲ ਹੋਇਆ,",
    "EXPECTED_FORMAT": "ਉਮੀਦ ਕੀਤੀ ਫਾਰਮੈਟ,",
    "INPUT_VALUES": "ਇਨਪੁਟ ਮੁੱਲ,",
    "RESTART": "ਮੁੜ ਸ਼ੁਰੂ ਕਰੋ,",
    "START_OVER": "ਮੁੜ ਸ਼ੁਰੂ ਕਰੋ,",
    "RESTART_CAPTURE": "ਕੈਪਚਰ ਕੀਤੇ ਇਨਪੁਟਸ ਨਾਲ ਮੁੜ ਸ਼ੁਰੂ ਕਰੋ,",
    "CANCEL": "ਰੱਦ ਕਰੋ,",
    "INTERRUPT_DIALOG": "ਵਿਘਟਿਤ ਸੰਵਾਦ ਕਾਰਜ,",
    "RUN": "ਚਲਾਓ,",
    "RUN_AGENT": "ਏਜੰਟ ਦੇ ਇਨਪੁਟ ਨਾਲ ਚਲਾਓ,",
    "STEP": "ਕਦਮ,",
    "DIALOG_TASK": "ਸੰਵਾਦ ਕਾਰਜ,",
    "FAQ": "ਅਕਸਰ ਪੁੱਛੇ ਜਾਣ ਵਾਲੇ ਪ੍ਰਸ਼ਨ,",
    "SNIPPET": "ਜਵਾਬ,",
    "ARTICLE": "ਵੈਬ ਪੇਜ,",
    "FILE": "ਫਾਈਲਾਂ,",
    "SUGGESTED": "ਸੁਝਾਏ ਗਏ,",
    "ALL_DIALOG": "ਸਾਰੇ ਸੰਵਾਦ ਕਾਰਜ,",
    "DIALOG_TEXT": "ਸੰਵਾਦ,",
    "INTENT_IDENTIFIED": "ਗਾਹਕ ਦਾ ਬੋਲ,",
    "NOT_WHAT_LOOKING": "ਗਲਤ ਸੁਝਾਅ?",
    "BOT": "ਬੋਟ,",
    "CUSTOMER": "ਗਾਹਕ,",
    "YOU": "ਤੁਸੀਂ,",
    "TERMINATE_CONV": "ਸੰਵਾਦ ਕਾਰਜ ਖਤਮ ਕਰੋ,",
    "TERMINATE_CONV_DESC": "ਕੀ ਤੁਸੀਂ ਯਕੀਨਨ ਸੰਵਾਦ ਕਾਰਜ ਖਤਮ ਕਰਨਾ ਚਾਹੁੰਦੇ ਹੋ? ਏਜੰਟ ਏਆਈ ਹੁਣ ਸਲਾਹ ਨਹੀਂ ਦੇ ਸਕੇਗਾ,",
    "YES_TERMINATE": "ਹਾਂ ਖਤਮ ਕਰੋ,",
    "NO_CANCEL": "ਨਹੀਂ, ਰੱਦ ਕਰੋ,",
    "OVERRIDE_CONTINUE": "ਓਵਰਰਾਈਡ ਮੋਡ ਨਾਲ ਜਾਰੀ ਰੱਖੋ,",
    "SUMMARY_TEXT": "ਸਾਰ,",
    "SUBMIT": "ਜਮ੍ਹਾਂ ਕਰੋ,",
    "INTERRUPT_OCCURED": "ਵਿਘਟਨ ਹੋਇਆ,",
    "IDENTIFIED_INTENT": "ਪਛਾਣਿਆ ਗਿਆ ਉਦੇਸ਼,",
    "INTERRUPT_DESC": "ਇਸ ਨੂੰ ਚਲਾਉਣ ਨਾਲ ਤੁਹਾਡਾ ਚੱਲ ਰਿਹਾ ਸੰਵਾਦ ਕਾਰਜ ਖਤਮ ਹੋ ਜਾਵੇਗਾ,",
    "ACCEPT_RUN": "ਸਵੀਕਾਰ ਕਰੋ ਅਤੇ ਚਲਾਓ,",
    "RUN_LATER": "ਬਾਅਦ ਵਿੱਚ ਚਲਾਓ,",
    "KNOW_MORE": "ਹੋਰ ਜਾਣੋ,",
    "MORE_TEXT": "ਹੋਰ,",
    "LESS_TEXT": "ਘੱਟ,",
    "VIEW_MORE": "ਹੋਰ ਵੇਖੋ,",
    "VIEW_LESS": "ਘੱਟ ਵੇਖੋ,",
    "SHOW_MORE_FAQ": "ਹੋਰ ਅਕਸਰ ਪੁੱਛੇ ਜਾਣ ਵਾਲੇ ਪ੍ਰਸ਼ਨ ਵੇਖੋ,",
    "SHOW_LESS_FAQ": "ਘੱਟ ਅਕਸਰ ਪੁੱਛੇ ਜਾਣ ਵਾਲੇ ਪ੍ਰਸ਼ਨ ਵੇਖੋ,",
    "SHOW_MORE_ARTICLE": "ਹੋਰ ਵੈਬ ਪੇਜ ਵੇਖੋ,",
    "SHOW_LESS_ARTICLE": "ਘੱਟ ਵੈਬ ਪੇਜ ਵੇਖੋ,",
    "SHOW_MORE_SNIPPET": "ਹੋਰ ਜਵਾਬ ਵੇਖੋ,",
    "SHOW_LESS_SNIPPET": "ਘੱਟ ਜਵਾਬ ਵੇਖੋ,",
    "SHOW_MORE_FILES": "ਹੋਰ ਫਾਈਲਾਂ ਵੇਖੋ,",
    "SHOW_LESS_FILES": "ਘੱਟ ਫਾਈਲਾਂ ਵੇਖੋ,",
    "VIEW_ALL_DIALOG": "ਸਾਰੇ ਸੰਵਾਦ ਵੇਖੋ,",
    "VIEW_FEW_DIALOG": "ਕੁਝ ਸੰਵਾਦ ਵੇਖੋ,",
    "HELP_FULL": "ਮਦਦਗਾਰ?",
    "THANKYOU": "ਧੰਨਵਾਦ!,",
    "EXPAND_MORE": "ਵੱਧਾਓ / ਹੋਰ,",
    "CLOSE_TEXT": "ਬੰਦ ਕਰੋ,",
    "STARTED": "ਸ਼ੁਰੂ ਹੋਇਆ,",
    "ENDED": "ਖਤਮ ਹੋਇਆ,",
    "VIEW_FULL_ARTICLE": "ਵੈਬ ਪੇਜ ਵੇਖੋ,",
    "VIEW_FULL_FILE": "ਫਾਈਲ ਵੇਖੋ,",
    "COPIED": "ਕਾਪੀ ਕੀਤਾ ਗਿਆ,",
    "SENTI_ANALY": "ਭਾਵਨਾ ਵਿਸ਼ਲੇਸ਼ਣ,",
    "WRONG_SUGGESTION": "ਗਲਤ ਸੁਝਾਅ,",
    "INCORRECT_INTENT": "ਗਲਤ ਉਦੇਸ਼,",
    "ACCIDENTAL_CLICK": "ਅਕਸਮਾਤ ਕਲਿੱਕ,",
    "TIME_TAKING": "ਸਮਾਂ ਲਗ ਰਿਹਾ ਹੈ,",
    "OTHER": "ਹੋਰ,",
    "PLAYBOOK_EMPTY_MSG": "ਪਲੇਬੁੱਕ ਚੁਣੋ,",
    "PLAYBOOK_EMPTY_DESC": "ਸਾਰੇ ਉਪਲਬਧ ਪਲੇਬੁੱਕਾਂ ਗਤਿਸ਼ੀਲ ਹੋਣ ਕਾਰਨ ਏਜੰਟ ਏਆਈ ਪਲੇਬੁੱਕ ਲੋਡ ਕਰਨ ਵਿੱਚ ਅਸਮਰੱਥ ਹੈ। ਪਲੇਬੁੱਕ ਤੱਕ ਪਹੁੰਚ ਕਰਨ ਲਈ 'ਪਲੇਬੁੱਕ ਚੁਣੋ' 'ਤੇ ਕਲਿੱਕ ਕਰੋ,",
    "STAGE": "ਮੰਚ,",
    "PROCEED_TO_CLOSE": "ਬੰਦ ਕਰਨ ਲਈ ਅਗੇ ਵਧੋ,",
    "RECOMENDED_PLAYBOOK": "ਸੁਝਾਇਆ ਗਿਆ ਪਲੇਬੁੱਕ,",
    "PRIMARY_SCRIPTS": "ਪ੍ਰਾਇਮਰੀ ਸਕ੍ਰਿਪਟਸ,",
    "DYNAMIC_SCRIPTS": "ਡਾਇਨਾਮਿਕ ਸਕ੍ਰਿਪਟਸ,",
    "RESUME": "ਪੁਨਰਾਰੰਭ,",
    "ENABLE_CLOSE": "ਬੰਦ ਮੰਚ ਨੂੰ ਯੋਗ ਕਰਨ ਲਈ ਬੰਦ ਕਰਨ ਲਈ ਅਗੇ ਵਧੋ ਬਟਨ 'ਤੇ ਕਲਿੱਕ ਕਰੋ,",
    "LIST_VIEW": "ਸੂਚੀ ਦ੍ਰਿਸ਼,",
    "TERMINATE": "ਖਤਮ ਕਰੋ,",
    "MINIMIZE": "ਨਿਊਨਤਮ ਕਰੋ,",
    "MAXIMIZE": "ਵੱਧਤਮ ਕਰੋ,",
    "NO_SEARCH_RESULT": "ਕੋਈ ਖੋਜ ਨਤੀਜਾ ਨਹੀਂ ਮਿਲਿਆ,",
    "SENTIMENT_AWAITING": "ਭਾਵਨਾ ਦੀ ਉਡੀਕ ਕਰ ਰਹੇ ਹਨ,",
    "POSITIVE": "ਸਕਾਰਾਤਮਕ,",
    "NEGATIVE": "ਨਕਾਰਾਤਮਕ,",
    "ASSOCIATED_WORK_NOTES": "ਪਿਛਲੇ ਹੱਲ ਦੇ ਨੋਟਸ,",
    "AGENT_JOINED_CONV": "ਏਜੰਟ ਗੱਲਬਾਤ ਵਿੱਚ ਸ਼ਾਮਲ ਹੋਇਆ,",
    "AUTOSCROLL_ASSIST": "ਆਟੋ-ਸਕ੍ਰੋਲ ਸਹਾਇਕ ਟੈਬ ਸਮੱਗਰੀ,",
    "FILE_SIZE_MSG": "ਫਾਈਲ ਦਾ ਆਕਾਰ 25MB ਦੇ ਅੰਦਰ ਹੋਣਾ ਚਾਹੀਦਾ ਹੈ। ਕਿਰਪਾ ਕਰਕੇ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ,",
    "OVERRIDE_BTN": "ਓਵਰਰਾਈਡ,",
    "CHOOSE_FILE": "ਫਾਈਲ ਚੁਣੋ,",
    "SUMMARY_ERROR_TEXT": "ਅਸੀਂ ਖੇਦਵਾਨ ਹਾਂ, ਪਰ ਇਸ ਗੱਲਬਾਤ ਲਈ ਸਾਰांਸ਼ ਤਿਆਰ ਕਰਨ ਵਿੱਚ ਸਮੱਸਿਆ ਆਈ। ਕਿਰਪਾ ਕਰਕੇ ਆਪਣਾ ਸਾਰੰਸ਼ ਬਣਾਓ,",
    "ASK_A_QUESTION": "ਇੱਕ ਸਵਾਲ ਪੁੱਛੋ",
    "COPY" : "ਨਕਲ",
    "TELL_US_MORE": "ਹੋਰ ਦੱਸੋ",
    "PLAYBOOK": "ਪਲੇਬੁੱਕ",
    "THANKS_FEEDBACK": "ਤੁਹਾਡੇ ਫੀਡਬੈਕ ਲਈ ਧੰਨਵਾਦ",
    "SOMETHING_WRONG": "ਕੁੱਝ ਗਲਤ ਹੋ ਗਿਆ ਹੈ",
    "CLICK_ERROR_DETAILS": "ਗਲਤੀ ਦੀ ਵਿਵਰਣੀ ਦੇਖਣ ਲਈ ਕਲਿਕ ਕਰੋ",
    "NO_ACTIVE_PLAYBOOK": "ਕੋਈ ਸਰਗਰਮ ਪਲੇਬੁੱਕ ਨਹੀਂ ਹੈ",
    "REPHRASE_QUESTION": "ਕੀ ਤੁਸੀਂ ਆਪਣੇ ਪ੍ਰਸ਼ਨ ਨੂੰ ਦੁਬਾਰਾ ਸ਼ਬਦਬੱਧ ਕਰ ਸਕਦੇ ਹੋ ਜਾਂ ਹੋਰ ਕੁਝ ਪੁੱਛ ਸਕਦੇ ਹੋ?",
    "INTERNAL_INFO": "ਅੰਦਰੂਨੀ ਜਾਣਕਾਰੀ",
    "SOURCES": "ਸਰੋਤ",
    "CONVERSATION_SUMMARY": "ਗੱਲਬਾਤ ਦਾ ਸਰਾਂਸ਼",
    "WAITING": "ਪ੍ਰਤੀਕਸ਼ਾ ਕਰ ਰਹੇ ਹਾਂ",
    "WIDGET_DISABLED": "ਵਿਜ਼ਟ ਨਿਸ਼ਕ੍ਰਿਯ ਕੀਤਾ ਗਿਆ ਹੈ",
    "AI_SETTINGS_DISABLED": "AI ਸੈਟਿੰਗਾਂ ਨਿਸ਼ਕ੍ਰਿਯ ਕੀਤੀਆਂ ਗਈਆਂ ਹਨ! ਕਿਰਪਾ ਕਰਕੇ AI ਪ੍ਰਬੰਧਕ ਨਾਲ ਸੰਪਰਕ ਕਰੋ",
    "SERVER_CONNECTION_ERROR": "ਸਰਵਰ ਨਾਲ ਜੁੜਨ ਵਿੱਚ ਗਲਤੀ",
    "VIEW": "ਵੇਖੋ",
    "ATTACHMENT_INPUT": "ਲਗਾਤਾਰ ਇਨਪੁਟ",
    "TYPE_SUMMARY": "ਸਾਰਾਂਸ਼ ਟਾਈਪ ਕਰੋ",
    "VIEW_FULL_ARTICLE_2": "ਪੂਰੀ ਲੇਖ ਵੇਖੋ",
    "VIEW_FULL_FILE_2": "ਪੂਰੀ ਫਾਈਲ ਵੇਖੋ",
    "BY":"ਦ੍ਵਾਰਾ",
    GENERATE_SUMMARY: "ਸਾਰਾਂਸ਼ ਤਿਆਰ ਕਰੋ",
    PREV_SUMMARIES: "ਪਹਿਲਾਂ ਬਣਾਏ ਗਏ ਸਾਰਾਂਸ਼",
    DIALOG_WORKFLOWS: "ਡਾਇਲਾਗ ਵਰਕਫਲੋ",
    SHOW_ALL_DIALOG: "ਸਾਰੇ ਡਾਇਲਾਗ ਟਾਸਕ ਦਿਖਾਓ",
    SHOW_ALL_DIALOGS: "ਸਾਰੇ ਡਾਇਲਾਗ ਦਿਖਾਓ",
    CUSTOM_TAB: "ਕਸਟਮ ਟੈਬ",
    AGENT_INPUT: "ਏਜੰਟ ਇਨਪੁਟ",
    "CUSTOM_EMPTY_MSG" : "ਕੋਈ ਸਰਗਰਮ ਪਲੇਬੁੱਕ ਨਹੀਂ ਹੈ",
    "CUSTOM_TAB_DESC" : "ਪਲੇਬੁੱਕ ਚਲਾਉਣ ਲਈ, ਸਕਰੀਨ ਦੇ ਨਿਚਲੇ ਭਾਗ ਵਿੱਚ ਉਪਲਬਧ ਤਾਲਿਕਾ ਤੋਂ ਇੱਕ ਚੁਣੋ",
    "SUBMIT_OVERALL_FEEDBACK" : "ਸਮਗਰੀਕਰਣ ਪਾਠਵਾਉਣਾ",
    "FEEDBACK_POPUP_SUBTITLE" : "ਵਿਜੈਟ ਅਤੇ ਇਸਦੀਆਂ ਸੁਵਿਧਾਵਾਂ ਬਾਰੇ ਤੁਹਾਡਾ ਸਨਤੁ਷ਿਤਾ",
    "FEEDBACK_SATISFIED" : "ਸਨਤੁ਷ਿਤ",
    "FEEDBACK_UNSATISFIED" : "ਸਨਤੁ਷ਿਤ ਨਹੀਂ",
    "FEEDBACK_PROVIDE_REASONS" : "ਹੋਰ ਜਾਣਕਾਰੀ ਦਿਓ…",
    "FEEDBACK_TITLE" : "ਪਾਠਵਾਉਣਾ",
    "AGENTIC_THINKING" : "ਸੋਚ ਰਿਹਾ ਹੈ",
    "AGENTIC_AGENT_TITLE" : "ਏਜੰਟ",
    "AGENTIC_COPILOT_MODE_TITLE" : "ਏਜੰਟਿਕ ਕੋਪਿਲੋਟ ਮੋਡ",
    "AGENTIC_SENDING_MESSAGE" : "ਭੇਜਿਆ ਜਾ ਰਿਹਾ ਹੈ...",
    "AGENTIC_COPILOT_DESC" : "Agentic Copilot ਤੁਹਾਡੀ ਗੱਲਬਾਤ ਨੂੰ ਸਰਗਰਮੀ ਨਾਲ ਸੁਣ ਰਿਹਾ ਹੈ ਅਤੇ ਆਪਣੇ ਆਪ ਮਦਦ ਕਰਨ ਲਈ ਤਿਆਰ ਹੈ",
    "AGENTIC_SEARCH_RESULTS" : "ਏਜੰਟ ਨਤੀਜੇ",
    "PAUSE_AUTO_SEND" : "ਸਵੈਚਾਲਿਤ ਭੇਜਣਾ ਰੋਕੋ",
    "PAUSE_AGENTIC" : "ਏਜੰਟ ਰੋਕੋ",
    "RESUME_AGENTIC" : "ਏਜੰਟ ਮੁੜ ਸ਼ੁਰੂ ਕਰੋ",
    "RESUME_AUTO_SEND" : "ਸਵੈਚਾਲਿਤ ਭੇਜਣਾ ਮੁੜ ਸ਼ੁਰੂ ਕਰੋ"
}